import variables from 'common/config/variables';
import { getScalablePixel } from 'common/utils';
import GlobalStyle from 'common/utils/GlobalStyle';
import React from 'react';

GlobalStyle.inject`
.metadata-separator {
  color: ${variables.font_color_c};
  opacity: 0.8;
}
`;

type MetadataSeparatorProps = {
  separator?: string;
  padding?: number;
  spacing?: number;
  size?: number;
};

const MetadataSeparator: React.FC<MetadataSeparatorProps> = ({
  separator,
  padding,
  size,
  spacing
}) => (
  <span
    className={'metadata-separator'}
    style={{
      marginLeft: padding && !spacing ? `${getScalablePixel(padding)}px` : undefined,
      padding: spacing ? `0 ${getScalablePixel(spacing)}px` : undefined,
      fontSize: size ? `${getScalablePixel(size)}px` : undefined
    }}
  >
    {separator || '·'}
  </span>
);

export default MetadataSeparator;
